import { ChartBar, ClipboardText, UserCircle } from '@phosphor-icons/react'

export const CHEF_TABS = [
  { id: 'reports', path: '/report', label: 'گزارش', icon: ChartBar, matches: (path: string) => path === '/report' || path.startsWith('/report/') },
  { id: 'orders', path: '/', label: 'سفارش', icon: ClipboardText, matches: (path: string) => path === '/' || path === '/shipping' },
  { id: 'profile', path: '/profile', label: 'نمایش', icon: UserCircle, matches: (path: string) => path === '/profile' || path.startsWith('/profile/') },
] as const
